import { Suspense } from "react";
import { QueryClientProvider } from "@tanstack/react-query";

import { ContentProvider } from "lib/content/use-content";
import { ContentLayoutProvider } from "lib/layout/use-content-layout";
import { captureException } from "lib/logger";
import { ModalsProvider } from "lib/modals/use-modals";
import { NavigationProvider } from "lib/navigation/use-navigation";
import { NotificationsProvider } from "lib/notifications/use-notifications";
import { prefetch } from "lib/prefetch";
import { SelectionColorProvider } from "lib/selection/selection-color";
import { SettingsProvider } from "lib/settings/use-settings";
import { Error } from "lib/ui/error";
import { Loader } from "lib/ui/loader";
import { ErrorBoundary } from "lib/utils/error-boundary";

import { Content } from "app/content";
import { Head } from "app/head";
import { Layout } from "app/layout";
import { SelectionMenu } from "app/selection-menu";
import { ShareQuote } from "app/share-quote";
import { queryClient } from "./query-client";

try {
  prefetch();
} catch (err) {
  captureException(err as Error);
}

export function App() {
  return (
    <ErrorBoundary fallback={<Error />}>
      <QueryClientProvider client={queryClient}>
        <Suspense fallback={<Loader />}>
          <SettingsProvider>
            <ContentLayoutProvider>
              <ContentProvider>
                <NavigationProvider>
                  <ModalsProvider>
                    <NotificationsProvider>
                      <SelectionColorProvider>
                        <SelectionMenu />
                        <Layout>
                          <Content />
                        </Layout>
                        <Head />
                        <ShareQuote />
                      </SelectionColorProvider>
                    </NotificationsProvider>
                  </ModalsProvider>
                </NavigationProvider>
              </ContentProvider>
            </ContentLayoutProvider>
          </SettingsProvider>
        </Suspense>
      </QueryClientProvider>
    </ErrorBoundary>
  );
}
